import React from 'react'
import Table from '../AgGrid/Table'
import { HoverTooltip } from '../HoverTooltip'

export const TableBox = ({
    objects,
    columns,
    position,
    onRowClick,
    disabled,
    height,
    t
}) => {
    return (
        <Table
            objects={objects}
            columns={columns}
            height={height}
            onRowClick={disabled ? undefined : onRowClick}
            noHover={disabled}
            t={t}
        />
    )
}